import api from '../client'

export async function fetchProjectOptions(search = '', page = 1, pageSize = 20) {
  const params = { search, page, page_size: pageSize, archive: false }
  const { data } = await api.get('/projects/', { params })
  const rawItems = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : []
  const items = rawItems.map((item) => ({
    value: String(item.id),
    label: item.project_code ? `${item.name} (${item.project_code})` : item.name,
  }))
  const hasMore = rawItems.length === pageSize
  return { items, hasMore }
}
